import { useMemo } from "react";
import { useDispatch } from "react-redux";

export const useAppButton = (
  path: string,
  absolutePath: boolean,
  onClick?: any,
) => {
  const dispatch = useDispatch();

  const onButtonClicked = useMemo(() => {
    if (path) {
      if (!absolutePath) {
        return () => (window.location.href = `#${path}`);
      } else {
        return () => window.open(path, "_blank");
      }
    } else {
      return onClick;
    }
  }, [dispatch, path, absolutePath, onClick]);

  return {
    onButtonClicked,
  };
};
